import Dashboard from 'views/Partner/Dashboard/Dashboard.jsx'

var partnerRoutes = [
    { path: "/partner/dashboard/", name: "Dashboard", icon: "pe-7s-graph1", component: Dashboard }
];
export default partnerRoutes;



// WEBPACK FOOTER //
// ./src/routes/partner.jsx